module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pre"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg4_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I’ve been a fiber artist for many decades. I also love photography. When digital processes and computers became readily available, I was able to create ways to combine fiber art and photography into innovative fiber photographs. I’m passionate about coming up with ideas and working out the kinks. This leads to more discoveries in an evolutionary process. I make the art and then the art makes me. This work always keeps me thinking, “What if … ?”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You can explore this creative digital process, manipulating original photography using a wide variety of photo-editing tools. Merging images digitally and/or physically by layering and fusing them with other surfaces, collage, and painted fabric or paper is a twenty-first-century art process.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("After a digital image is composed, you decide what substrate (surface) would best enhance the image. It can be printed directly onto an assortment of created inkjet-ready substrates, papers, and mixed-media surfaces.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Another variable is presentation—what would best suit the final print? Should it be finished as a wholecloth photo art quilt, a holographic image, or a segmented foldable work, or collaged into mixed-media art? Add creative stitching with the sewing lines serving as drawing lines. Every work is created individually, with unique results.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I hope this book inspires you to discover new ways of creating images, printing on innovative substrates, and presenting your work.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c6c494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_preface.vue
// module id = 63
// module chunks = 0